import QRCode from "qrcode";
import { useEffect, useState } from "react";

/** QR-код приглашения (SVG — не требует canvas). */
export function QrCode({ text }: { text: string }) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toString(text, {
      type: "svg",
      margin: 1,
      color: { dark: "#000000", light: "#ffffff" },
    })
      .then((result) => !cancelled && setSvg(result))
      .catch(() => !cancelled && setSvg(null));
    return () => {
      cancelled = true;
    };
  }, [text]);

  return (
    <div className="qr-frame" role="img" aria-label="QR-код для подключения к комнате">
      {svg ? (
        // SVG сгенерирован библиотекой из нашей же ссылки, пользовательского HTML тут нет
        <div dangerouslySetInnerHTML={{ __html: svg }} />
      ) : (
        <div className="qr-frame__placeholder" />
      )}
    </div>
  );
}
